// @flow

// Dominik; 02.05.2023; this should not be used anymore, instead import from UI
export * from '../components/UI/utils/feedbackMessages'
